import { useSelector } from 'react-redux';
import { Flex, FloraTypography } from '@grupoboticario/flora-react';
import { BellPlusIcon } from '@grupoboticario/flora-react-icons';
import type { RootState } from 'core';
import { ModalUnavailableItemsStyles } from 'ui/pages/Cart/components/ModalUnavailableItems/ModalUnavailableItems.styles';
import { useModalUnavailableItems } from 'ui/pages/Cart/hooks/useModalUnavailableItems';

export const UnavailableItems = () => {
  const unavailableItems = useSelector((state: RootState) => state.cart.data.unavailableItems);
  const { getImage, handleBuyIntention } = useModalUnavailableItems();
  return (
    <>
      <ModalUnavailableItemsStyles.BoxInfo>
        <FloraTypography tabIndex={0} fontSize="bodyLargeShort">
          {unavailableItems.length < 10 ? `0${unavailableItems.length}` : unavailableItems.length}{' '}
          {unavailableItems.length > 1
            ? 'itens estavam em seu pedido e foram removidos por falta de estoque'
            : 'item estava em seu pedido e foi removido por falta de estoque'}
        </FloraTypography>
      </ModalUnavailableItemsStyles.BoxInfo>
      {unavailableItems.map((item) => (
        <ModalUnavailableItemsStyles.BoxProduct direction="row" gap="$4" key={item.sku}>
          <ModalUnavailableItemsStyles.ImgProduct src={getImage(item.image)} />
          <Flex direction="column">
            <div>
              <FloraTypography
                tabIndex={0}
                aria-label={`O SKU do produto é ${item.sku}`}
                fontSize="exceptionsAuxiliar"
              >
                {item.sku}
              </FloraTypography>
            </div>
            <div>
              <FloraTypography
                tabIndex={0}
                aria-label={`O nome do produto é ${item.name}`}
                fontSize="exceptionsAuxiliar"
              >
                {item.name}
              </FloraTypography>
            </div>
            <div>
              <FloraTypography
                tabIndex={0}
                aria-label={`A quantidade é ${item.quantity}`}
                fontSize="exceptionsAuxiliar"
              >
                Quantidade: {item.quantity}
              </FloraTypography>
            </div>
            <div>
              <ModalUnavailableItemsStyles.Button
                data-unavaliable="true"
                has="iconRight"
                icon={<BellPlusIcon size={16} />}
                variant="ghost"
                onClick={() => handleBuyIntention(item.sku, item.name)}
                aria-label={`Avise-me quando o produto ${item.name} estiver disponível`}
              >
                Avise-me
              </ModalUnavailableItemsStyles.Button>
            </div>
          </Flex>
        </ModalUnavailableItemsStyles.BoxProduct>
      ))}
    </>
  );
};
